import { Component } from 'react'
import { withRouter } from 'react-router-dom'

/**
 * Basic component that provides work-around functionality for scroll
 * management.
 * https://reacttraining.com/react-router/web/guides/scroll-restoration
 */
class ScrollToTop extends Component {
  /**
   * Handle React event
   * @param prevProps
   */
  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  /**
   * Render component
   */
  render () {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js